export const firstAidData = [
  {
    id: 'cuts-wounds',
    name: 'staticPages.homePageChild.cards.firstAid.cutsAndWounds',
    image: 'cutsBanner',
    introduction: 'firstaid.child.cuts.videoCaption',
    videoLink: 'firstaid.child.cuts.videoLink',
    steps: {
      intro: {
        mascot: 'whatIs',
        text: 'firstaid.child.cuts.intro',
        definition: 'firstaid.child.cuts.definition',
      },
      whatHelps: {
        mascot: 'whatToDo',
        question: 'firstaid.child.cuts.whatHelps.question',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'washHands',
            label: 'firstaid.child.cuts.whatHelps.options.option1',
            icon: 'washHands',
          },
          {
            id: 'press',
            label: 'firstaid.child.cuts.whatHelps.options.option2',
            icon: 'press',
          },
          {
            id: 'clean',
            label: 'firstaid.child.cuts.whatHelps.options.option3',
            icon: 'clean',
          },
          {
            id: 'cover',
            label: 'firstaid.child.cuts.whatHelps.options.option4',
            icon: 'cover',
          },
        ],
      },
      whenToSay: {
        mascot: 'whenToWorry',
        question: 'firstaid.child.cuts.whenToSay.question',
        stepcolors: ['#FF2B26', '#FF8A00', '#FF8A00', '#FF2B26'],
        options: [
          {
            id: 'deep_cut',
            label: 'firstaid.child.cuts.whenToSay.options.option1',
            icon: 'deepCut',
          },
          {
            id: 'bleeding',
            label: 'firstaid.child.cuts.whenToSay.options.option2',
            icon: 'bleeding',
          },
          {
            id: 'bad_pain',
            label: 'firstaid.child.cuts.whenToSay.options.option3',
            icon: 'badPain',
          },
          {
            id: 'bite',
            label: 'firstaid.child.cuts.whenToSay.options.option4',
            icon: 'bite',
          },
        ],
      },
      quizMCQ1: {
        mascot: 'askingQuickCheck',
        intro: 'firstaid.child.cuts.quiz1.intro',
        question: 'firstaid.child.cuts.quiz1.question',
        answer: 'firstaid.child.cuts.quiz1.answer',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'opt1',
            label: 'firstaid.child.cuts.quiz1.options.option1',
            icon: 'press',
            correct: true,
          },
          {
            id: 'opt2',
            label: 'firstaid.child.cuts.quiz1.options.option2',
            icon: 'pourOil',
            correct: false,
          },
          {
            id: 'opt3',
            label: 'firstaid.child.cuts.quiz1.options.option3',
            icon: 'deepCut',
            correct: false,
          },
          {
            id: 'opt4',
            label: 'firstaid.child.cuts.quiz1.options.option4',
            icon: 'putSugar',
            correct: false,
          },
        ],
        feedback: {
          correct: 'firstaid.child.cuts.quiz1.correct',
          wrong: 'firstaid.child.cuts.quiz1.wrong',
        },
      },
      quizMCQ2: {
        mascot: 'askingQuickCheck',
        intro: 'firstaid.child.cuts.quiz2.intro',
        question: 'firstaid.child.cuts.quiz2.question',
        answer: 'firstaid.child.cuts.quiz2.answer',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'opt1',
            label: 'firstaid.child.cuts.quiz2.options.option1',
            icon: 'toothpaste',
            correct: false,
          },
          {
            id: 'opt2',
            label: 'firstaid.child.cuts.quiz2.options.option2',
            icon: 'pourOil',
            correct: false,
          },
          {
            id: 'opt3',
            label: 'firstaid.child.cuts.quiz2.options.option3',
            icon: 'clean',
            correct: true,
          },
          {
            id: 'opt4',
            label: 'firstaid.child.cuts.quiz2.options.option4',
            icon: 'putSugar',
            correct: false,
          },
        ],
        feedback: {
          correct: 'firstaid.child.cuts.quiz2.correct',
          wrong: 'firstaid.child.cuts.quiz2.wrong',
        },
      },
      quizBoolean: {
        mascot: 'askingQuickCheck',
        intro: 'firstaid.child.cuts.quiz3.intro',
        question: 'firstaid.child.cuts.quiz3.question',
        answer: 'firstaid.child.cuts.quiz3.answer',
        options: ['firstaid.child.cuts.quiz3.options.option1', 'firstaid.child.cuts.quiz3.options.option2'],
        feedback: {
          correct: 'firstaid.child.cuts.quiz3.correct',
          wrong: 'firstaid.child.cuts.quiz3.wrong',
        },
      },
      finish: {
        type: 'finish',
        message: 'firstaid.child.cuts.finish',
      },
    },
  },
  {
    id: 'nose-bleeding',
    name: 'staticPages.homePageChild.cards.firstAid.noseBleeding',
    image: 'noseBleedingBanner',
    introduction: 'firstaid.child.nosebleeding.videoCaption',
    videoLink: 'firstaid.child.nosebleeding.videoLink',
    steps: {
      intro: {
        mascot: 'whatIs',
        text: 'firstaid.child.nosebleeding.intro',
        definition: 'firstaid.child.nosebleeding.definition',
      },
      whatHelps: {
        mascot: 'whatToDo',
        question: 'firstaid.child.nosebleeding.whatHelps.question',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'sitUp',
            label: 'firstaid.child.nosebleeding.whatHelps.options.option1',
            icon: 'sitUp',
          },
          {
            id: 'leanFoward',
            label: 'firstaid.child.nosebleeding.whatHelps.options.option2',
            icon: 'leanFoward',
          },
          {
            id: 'pinchSoftPart',
            label: 'firstaid.child.nosebleeding.whatHelps.options.option3',
            icon: 'pinchSoftPart',
          },
          {
            id: 'breatheViaMouth',
            label: 'firstaid.child.nosebleeding.whatHelps.options.option4',
            icon: 'breatheViaMouth',
          },
        ],
      },
      whenToSay: {
        mascot: 'whenToWorry',
        question: 'firstaid.child.nosebleeding.whenToSay.question',
        stepcolors: ['#FF2B26', '#FF8A00', '#FF8A00', '#FF2B26'],
        options: [
          {
            id: 'alotofbleeding',
            label: 'firstaid.child.nosebleeding.whenToSay.options.option1',
            icon: 'alotOfBlood',
          },
          {
            id: 'bleedingContinous',
            label: 'firstaid.child.nosebleeding.whenToSay.options.option2',
            icon: 'bleedingNotStopping',
          },
          {
            id: 'breathingDifficulties',
            label: 'firstaid.child.nosebleeding.whenToSay.options.option3',
            icon: 'breathingDifficulties',
          },
          {
            id: 'swollenNose',
            label: 'firstaid.child.nosebleeding.whenToSay.options.option4',
            icon: 'swollenNose',
          },
        ],
      },
      quizMCQ1: {
        mascot: 'askingQuickCheck',
        intro: 'firstaid.child.nosebleeding.quiz1.intro',
        question: 'firstaid.child.nosebleeding.quiz1.question',
        answer: 'firstaid.child.nosebleeding.quiz1.answer',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'opt1',
            label: 'firstaid.child.nosebleeding.quiz1.options.option1',
            icon: 'run',
            correct: false,
          },
          {
            id: 'opt2',
            label: 'firstaid.child.nosebleeding.quiz1.options.option2',
            icon: 'lieFlat',
            correct: false,
          },
          {
            id: 'opt3',
            label: 'firstaid.child.nosebleeding.quiz1.options.option3',
            icon: 'breatheViaNose',
            correct: false,
          },
          {
            id: 'opt4',
            label: 'firstaid.child.nosebleeding.quiz1.options.option4',
            icon: 'sitUp',
            correct: true,
          },
        ],
      },
      quizMCQ2: {
        mascot: 'askingQuickCheck',
        intro: 'firstaid.child.nosebleeding.quiz2.intro',
        question: 'firstaid.child.nosebleeding.quiz2.question',
        answer: 'firstaid.child.nosebleeding.quiz2.answer',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'opt1',
            label: 'firstaid.child.nosebleeding.quiz2.options.option1',
            icon: 'breatheViaNose',
            correct: false,
          },
          {
            id: 'opt2',
            label: 'firstaid.child.nosebleeding.quiz2.options.option2',
            icon: 'putThings',
            correct: false,
          },
          {
            id: 'opt3',
            label: 'firstaid.child.nosebleeding.quiz2.options.option3',
            icon: 'run',
            correct: false,
          },
          {
            id: 'opt4',
            label: 'firstaid.child.nosebleeding.quiz2.options.option4',
            icon: 'pinchSoftPart',
            correct: true,
          },
        ],
      },
      quizBoolean: {
        mascot: 'askingQuickCheck',
        intro: 'firstaid.child.cuts.quiz3.intro',
        question: 'firstaid.child.cuts.quiz3.question',
        answer: 'firstaid.child.cuts.quiz3.answer',
        options: ['firstaid.child.cuts.quiz3.options.option1', 'firstaid.child.cuts.quiz3.options.option2'],
      },
    },
  },
  {
    id: 'burns',
    name: 'staticPages.homePageChild.cards.firstAid.burnsAndScalds',
    image: 'burnsBanner',
    introduction: 'firstaid.child.burns.videoCaption',
    videoLink: 'firstaid.child.burns.videoLink',
    steps: {
      intro: {
        mascot: 'whatIs',
        text: 'firstaid.child.burns.intro',
        definition: 'firstaid.child.burns.definition',
      },
      whatHelps: {
        mascot: 'whatToDo',
        question: 'firstaid.child.burns.whatHelps.question',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'stayAwayFire',
            label: 'firstaid.child.burns.whatHelps.options.option1',
            icon: 'stayAwayFire',
          },
          {
            id: 'coolWithWater',
            label: 'firstaid.child.burns.whatHelps.options.option2',
            icon: 'coolWithWater',
          },
          {
            id: 'coverBurn',
            label: 'firstaid.child.burns.whatHelps.options.option3',
            icon: 'coverBurn',
          },
          {
            id: 'takeMedicine',
            label: 'firstaid.child.burns.whatHelps.options.option4',
            icon: 'takeMedicine',
          },
        ],
      },
      whenToSay: {
        mascot: 'whenToWorry',
        question: 'firstaid.child.burns.whenToSay.question',
        stepcolors: ['#FF2B26', '#FF8A00', '#FF8A00', '#FF2B26'],
        options: [
          {
            id: 'burntHand',
            label: 'firstaid.child.burns.whenToSay.options.option1',
            icon: 'burntHand',
          },
          {
            id: 'blister',
            label: 'firstaid.child.burns.whenToSay.options.option2',
            icon: 'blister',
          },
          {
            id: 'fromChemicals',
            label: 'firstaid.child.burns.whenToSay.options.option3',
            icon: 'fromChemicals',
          },
          {
            id: 'cantBreathe',
            label: 'firstaid.child.burns.whenToSay.options.option4',
            icon: 'cantBreathe',
          },
        ],
      },
      quizMCQ1: {
        mascot: 'askingQuickCheck',
        intro: 'firstaid.child.burns.quiz1.intro',
        question: 'firstaid.child.burns.quiz1.question',
        answer: 'firstaid.child.burns.quiz1.answer',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'opt1',
            label: 'firstaid.child.burns.quiz1.options.option1',
            icon: 'burnsPutSugar',
            correct: false,
          },
          {
            id: 'opt2',
            label: 'firstaid.child.burns.quiz1.options.option2',
            icon: 'burnsPutWater',
            correct: true,
          },
          {
            id: 'opt3',
            label: 'firstaid.child.burns.quiz1.options.option3',
            icon: 'blister',
            correct: false,
          },
          {
            id: 'opt4',
            label: 'firstaid.child.burns.quiz1.options.option4',
            icon: 'burnsPourOil',
            correct: false,
          },
        ],
      },
      quizMCQ2: {
        mascot: 'askingQuickCheck',
        intro: 'firstaid.child.burns.quiz2.intro',
        question: 'firstaid.child.burns.quiz2.question',
        answer: 'firstaid.child.burns.quiz2.answer',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'opt1',
            label: 'firstaid.child.burns.quiz2.options.option1',
            icon: 'aFewSeconds',
            correct: false,
          },
          {
            id: 'opt2',
            label: 'firstaid.child.burns.quiz2.options.option2',
            icon: 'manyMinutes',
            correct: true,
          },
          {
            id: 'opt3',
            label: 'firstaid.child.burns.quiz2.options.option3',
            icon: 'manyMinutes',
            correct: false,
          },
          {
            id: 'opt4',
            label: 'firstaid.child.burns.quiz2.options.option4',
            icon: 'oneHour',
            correct: false,
          },
        ],
      },
      quizBoolean: {
        mascot: 'askingQuickCheck',
        intro: 'firstaid.child.burns.quiz3.intro',
        question: 'firstaid.child.burns.quiz3.question',
        answer: 'firstaid.child.burns.quiz3.answer',
        options: ['firstaid.child.burns.quiz3.options.option1', 'firstaid.child.cuts.quiz3.options.option2'],
      },
    },
  },
  {
    id: 'fractures',
    name: 'staticPages.homePageChild.cards.firstAid.fractures',
    image: 'fracturesBanner',
    introduction: 'firstaid.child.fractures.videoCaption',
    videoLink: 'firstaid.child.fractures.videoLink',
    steps: {
      intro: {
        mascot: 'whatIs',
        text: 'firstaid.child.fractures.intro',
        definition: 'firstaid.child.fractures.definition',
      },
      whatHelps: {
        mascot: 'whatToDo',
        question: 'firstaid.child.fractures.whatHelps.question',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          // Swapped 1 with 3 option
          {
            id: 'injuredPartStill',
            label: 'firstaid.child.fractures.whatHelps.options.option3',
            icon: 'injuredPartStill',
          },
          {
            id: 'support',
            label: 'firstaid.child.fractures.whatHelps.options.option2',
            icon: 'support',
          },
          {
            id: 'coldCloth',
            label: 'firstaid.child.fractures.whatHelps.options.option1',
            icon: 'coldCloth',
          },
          {
            id: 'healthFacility',
            label: 'firstaid.child.fractures.whatHelps.options.option4',
            icon: 'healthFacility',
          },
        ],
      },
      whenToSay: {
        mascot: 'whenToWorry',
        question: 'firstaid.child.fractures.whenToSay.question',
        stepcolors: ['#FF2B26', '#FF8A00', '#FF8A00', '#FF2B26'],
        options: [
          {
            id: 'strongPain',
            label: 'firstaid.child.fractures.whenToSay.options.option1',
            icon: 'strongPain',
          },
          {
            id: 'partSwollen',
            label: 'firstaid.child.fractures.whenToSay.options.option2',
            icon: 'partSwollen',
          },
          {
            id: 'partBent',
            label: 'firstaid.child.fractures.whenToSay.options.option3',
            icon: 'partBent',
          },
          {
            id: 'cannotMove',
            label: 'firstaid.child.fractures.whenToSay.options.option4',
            icon: 'cannotMove',
          },
        ],
      },
      quizMCQ1: {
        mascot: 'askingQuickCheck',
        intro: 'firstaid.child.fractures.quiz1.intro',
        question: 'firstaid.child.fractures.quiz1.question',
        answer: 'firstaid.child.fractures.quiz1.answer',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'opt1',
            label: 'firstaid.child.fractures.quiz1.options.option1',
            icon: 'skinInfection',
            correct: false,
          },
          {
            id: 'opt2',
            label: 'firstaid.child.fractures.quiz1.options.option2',
            icon: 'stomachIllness',
            correct: false,
          },
          {
            id: 'opt3',
            label: 'firstaid.child.fractures.quiz1.options.option3',
            icon: 'brokenBone',
            correct: true,
          },
          {
            id: 'opt4',
            label: 'firstaid.child.fractures.quiz1.options.option4',
            icon: 'changesOnSkin',
            correct: false,
          },
        ],
      },
      quizMCQ2: {
        mascot: 'askingQuickCheck',
        intro: 'firstaid.child.fractures.quiz2.intro',
        question: 'firstaid.child.fractures.quiz2.question',
        answer: 'firstaid.child.fractures.quiz2.answer',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'opt1',
            label: 'firstaid.child.fractures.quiz2.options.option1',
            icon: 'massage',
            correct: false,
          },
          {
            id: 'opt2',
            label: 'firstaid.child.fractures.quiz2.options.option2',
            icon: 'healthFacility',
            correct: true,
          },
          {
            id: 'opt3',
            label: 'firstaid.child.fractures.quiz2.options.option3',
            icon: 'continuePlaying',
            correct: false,
          },
          {
            id: 'opt4',
            label: 'firstaid.child.fractures.quiz2.options.option4',
            icon: 'fracturesRun',
            correct: false,
          },
        ],
      },
      quizBoolean: {
        mascot: 'askingQuickCheck',
        intro: 'firstaid.child.fractures.quiz3.intro',
        question: 'firstaid.child.fractures.quiz3.question',
        answer: 'firstaid.child.fractures.quiz3.answer',
        options: ['firstaid.child.fractures.quiz3.options.option1', 'firstaid.child.fractures.quiz3.options.option2'],
      },
    },
  },
  {
    id: 'choking',
    name: 'staticPages.homePageChild.cards.firstAid.choking',
    image: 'coughing',
    introduction: 'firstaid.child.choking.videoCaption',
    videoLink: 'firstaid.child.choking.videoLink',
    steps: {
      intro: {
        mascot: 'whatIs',

        text: 'firstaid.child.choking.intro',
        definition: 'firstaid.child.choking.definition',
      },
      whatHelps: {
        mascot: 'whatToDo',
        question: 'firstaid.child.choking.whatHelps.question',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'coughing',
            label: 'firstaid.child.choking.whatHelps.options.option2',
            icon: 'swallowingCough',
          },
          {
            id: 'patBack',
            label: 'firstaid.child.choking.whatHelps.options.option1',
            icon: 'patBack',
          },
          {
            id: 'stayBehind',
            label: 'firstaid.child.choking.whatHelps.options.option3',
            icon: 'standBehind',
          },
          {
            id: '5Blows',
            label: 'firstaid.child.choking.whatHelps.options.option4',
            icon: 'pushes',
          },
        ],
      },
      whenToSay: {
        mascot: 'whenToWorry',
        question: 'firstaid.child.choking.whenToSay.question',
        stepcolors: ['#FF2B26', '#FF8A00', '#FF8A00', '#FF2B26'],
        options: [
          {
            id: 'cantCry',
            label: 'firstaid.child.choking.whenToSay.options.option1',
            icon: 'stuckFood',
          },
          {
            id: 'notBreathing',
            label: 'firstaid.child.choking.whenToSay.options.option2',
            icon: 'notBreathing',
          },
          {
            id: 'fainted',
            label: 'firstaid.child.choking.whenToSay.options.option3',
            icon: 'fainted',
          },
          {
            id: 'coughing',
            label: 'firstaid.child.choking.whenToSay.options.option4',
            icon: 'swallowingCough',
          },
        ],
      },
      quizMCQ1: {
        mascot: 'askingQuickCheck',
        intro: 'firstaid.child.choking.quiz1.intro',
        question: 'firstaid.child.choking.quiz1.question',
        answer: 'firstaid.child.choking.quiz1.answer',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'opt1',
            label: 'firstaid.child.choking.quiz1.options.option1',
            icon: 'stomachAche',
            correct: false,
          },
          {
            id: 'opt2',
            label: 'firstaid.child.choking.quiz1.options.option2',
            icon: 'sneezing',
            correct: false,
          },
          {
            id: 'opt3',
            label: 'firstaid.child.choking.quiz1.options.option3',
            icon: 'stuckFood',
            correct: true,
          },
          {
            id: 'opt4',
            label: 'firstaid.child.choking.quiz1.options.option4',
            icon: 'skinRash',
            correct: false,
          },
        ],
      },
      quizMCQ2: {
        mascot: 'askingQuickCheck',
        intro: 'firstaid.child.choking.quiz2.intro',
        question: 'firstaid.child.choking.quiz2.question',
        answer: 'firstaid.child.choking.quiz2.answer',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'opt1',
            label: 'firstaid.child.choking.quiz2.options.option1',
            icon: 'feedBaby',
            correct: false,
          },
          {
            id: 'opt2',
            label: 'firstaid.child.choking.quiz2.options.option2',
            icon: 'shakeBaby',
            correct: false,
          },
          {
            id: 'opt3',
            label: 'firstaid.child.choking.quiz2.options.option3',
            icon: 'patBaby',
            correct: true,
          },
          {
            id: 'opt4',
            label: 'firstaid.child.choking.quiz2.options.option4',
            icon: 'rush',
            correct: false,
          },
        ],
      },
      quizBoolean: {
        mascot: 'askingQuickCheck',
        intro: 'firstaid.child.choking.quiz3.intro',
        question: 'firstaid.child.choking.quiz3.question',
        answer: 'firstaid.child.choking.quiz3.answer',
        options: ['firstaid.child.choking.quiz3.options.option1', 'firstaid.child.choking.quiz3.options.option2'],
      },
    },
  },
  {
    id: 'poisoning',
    name: 'staticPages.homePageChild.cards.firstAid.poisoning',
    image: 'coughing',
    introduction: 'firstaid.child.poisoning.videoCaption',
    videoLink: 'firstaid.child.poisoning.videoLink',
    steps: {
      intro: {
        mascot: 'whatIs',
        text: 'firstaid.child.poisoning.intro',
        definition: 'firstaid.child.poisoning.definition',
      },
      whatHelps: {
        mascot: 'whatToDo',
        question: 'firstaid.child.poisoning.whatHelps.question',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'patBack',
            label: 'firstaid.child.poisoning.whatHelps.options.option1',
            icon: 'freshAir',
          },
          {
            id: 'washSkin',
            label: 'firstaid.child.poisoning.whatHelps.options.option2',
            icon: 'washSkin',
          },
          {
            id: 'washMouth',
            label: 'firstaid.child.poisoning.whatHelps.options.option3',
            icon: 'washMouth',
          },
          {
            id: 'hospital',
            label: 'firstaid.child.poisoning.whatHelps.options.option4',
            icon: 'hospital',
          },
        ],
      },
      whenToSay: {
        mascot: 'whenToWorry',
        question: 'firstaid.child.poisoning.whenToSay.question',
        stepcolors: ['#FF2B26', '#FF8A00', '#FF8A00', '#FF2B26'],
        options: [
          {
            id: 'sleepy',
            label: 'firstaid.child.poisoning.whenToSay.options.option1',
            icon: 'sleepy',
          },
          {
            id: 'shaking',
            label: 'firstaid.child.poisoning.whenToSay.options.option2',
            icon: 'shaking',
          },
          {
            id: 'throwingUp',
            label: 'firstaid.child.poisoning.whenToSay.options.option3',
            icon: 'throwingUp',
          },
          {
            id: 'coughing',
            label: 'firstaid.child.poisoning.whenToSay.options.option4',
            icon: 'swallowedCoughing',
          },
        ],
      },
      quizMCQ1: {
        mascot: 'askingQuickCheck',
        intro: 'firstaid.child.poisoning.quiz1.intro',
        question: 'firstaid.child.poisoning.quiz1.question',
        answer: 'firstaid.child.poisoning.quiz1.answer',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'opt1',
            label: 'firstaid.child.poisoning.quiz1.options.option1',
            icon: 'stomachAching',
            correct: false,
          },
          {
            id: 'opt2',
            label: 'firstaid.child.poisoning.quiz1.options.option2',
            icon: 'sneezingAlot',
            correct: false,
          },
          {
            id: 'opt3',
            label: 'firstaid.child.poisoning.quiz1.options.option3',
            icon: 'swallowedPoison',
            correct: true,
          },
          {
            id: 'opt4',
            label: 'firstaid.child.poisoning.quiz1.options.option4',
            icon: 'sskinRash',
            correct: false,
          },
        ],
      },
      quizMCQ2: {
        mascot: 'askingQuickCheck',
        intro: 'firstaid.child.poisoning.quiz2.intro',
        question: 'firstaid.child.poisoning.quiz2.question',
        answer: 'firstaid.child.poisoning.quiz2.answer',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'opt1',
            label: 'firstaid.child.poisoning.quiz2.options.option1',
            icon: 'feedBaby',
            correct: false,
          },
          {
            id: 'opt2',
            label: 'firstaid.child.poisoning.quiz2.options.option2',
            icon: 'shakeBaby',
            correct: false,
          },
          {
            id: 'opt3',
            label: 'firstaid.child.poisoning.quiz2.options.option3',
            icon: 'healthFacility',
            correct: true,
          },
          {
            id: 'opt4',
            label: 'firstaid.child.poisoning.quiz2.options.option4',
            icon: 'chockingRun',
            correct: false,
          },
        ],
      },
      quizBoolean: {
        mascot: 'askingQuickCheck',
        intro: 'firstaid.child.poisoning.quiz3.intro',
        question: 'firstaid.child.poisoning.quiz3.question',
        answer: 'firstaid.child.poisoning.quiz3.answer',
        options: ['firstaid.child.poisoning.quiz3.options.option1', 'firstaid.child.poisoning.quiz3.options.option2'],
      },
    },
  },
];
